// components/Dashboard/tabs/ChannelsTab.js
import React, { useState, useRef } from 'react';
import './ChannelsTab.css';

// Platform Components
import TelegramChannels from './platforms/TelegramChannels';
import YoutubeChannels from './platforms/YoutubeChannels';
import InstagramChannels from './platforms/InstagramChannels';
import XChannels from './platforms/XChannels';
import TiktokChannels from './platforms/TiktokChannels';
import { API_URL, BASE_URL } from '../../../config';

const ChannelsTab = (props) => {
  const {
    channels,
    channelStats,
    loadingStats,
    mtprotoStatus,
    onAddChannel,
    onEditChannel,
    onDeleteChannel,
    onFetchChannelStats,
    onRefreshChannels,
    showMessage,
    BASE_URL,
    onNavigateToLibrary,
    onNavigateToAutomation,
    selectedProfile
  } = props;

  const [selectedPlatform, setSelectedPlatform] = useState('telegram');
  const [connectingPlatform, setConnectingPlatform] = useState(null); // YENİ

  // Platform component refs
  const youtubeRef = useRef(null);
  const instagramRef = useRef(null);
  const xRef = useRef(null);
  const tiktokRef = useRef(null);

  // Platform ikonları SVG olarak
  const platformIcons = {
    telegram: (
      <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.56c-.21 2.27-1.13 7.75-1.6 10.29-.2 1.08-.59 1.44-.97 1.47-.82.07-1.45-.54-2.24-.97-1.24-.71-1.94-1.14-3.14-1.83-1.39-.79-.49-1.23.3-1.94.21-.19 3.85-3.52 3.91-3.82.01-.04.01-.19-.07-.27-.09-.08-.22-.05-.32-.03-.13.03-2.3 1.46-6.5 4.29-.61.42-1.17.63-1.67.62-.55-.01-1.6-.31-2.39-.56-.96-.31-1.72-.47-1.66-.99.04-.27.42-.55 1.16-.83 4.54-1.98 7.57-3.29 9.1-3.93 4.33-1.82 5.23-2.14 5.82-2.15.13 0 .41.03.59.18.15.12.19.29.21.43.02.14.05.37.03.57z" />
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
    x: (
      <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    tiktok: (
      <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
      </svg>
    ),
    instagram: (
      <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
      </svg>
    )
  };

  // Platform yapılandırması - HER PLATFORMUN BUTON YAPILANDIRMASI
  const platforms = [
    {
      id: 'telegram',
      name: 'Telegram',
      color: '#0088cc',
      enabled: true,
      description: 'Telegram kanallarınızı yönetin ve otomatik paylaşım kuralları oluşturun',
      actions: {
        refresh: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          ),
          label: 'Yenile',
          color: '#4caf50'
        },
        add: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          ),
          label: 'Ekle',
          color: '#667eea'
        }
      }
    },
    {
      id: 'youtube',
      name: 'YouTube',
      color: '#ff0000',
      enabled: true,
      description: 'YouTube kanallarınızı bağlayın ve videolarınızı paylaşın',
      actions: {
        add: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          ),
          label: 'Kanal Ekle',
          color: '#ff0000'
        }
      }
    },
    {
      id: 'instagram',
      name: 'Instagram',
      color: '#E4405F',
      enabled: true,
      description: 'Instagram hesaplarınızı yönetin ve gönderilerinizi planlayın',
      actions: {
        refresh: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          ),
          label: 'Yenile',
          color: '#4caf50'
        },
        add: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          ),
          label: 'Hesap Ekle',
          color: '#E4405F'
        }
      }
    },
    {
      id: 'x',
      name: 'X (Twitter)',
      color: '#000000',
      enabled: true,
      description: 'X hesaplarınızı yönetin ve tweet\'lerinizi planlayın',
      actions: {
        refresh: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          ),
          label: 'Yenile',
          color: '#4caf50'
        },
        add: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          ),
          label: 'Hesap Ekle',
          color: '#000000'
        }
      }
    },
    {
      id: 'tiktok',
      name: 'TikTok',
      color: '#000000',
      enabled: true,
      comingSoon: false,
      description: 'TikTok hesaplarınızı bağlayın ve videolarınızı paylaşın',
      actions: {
        refresh: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          ),
          label: 'Yenile',
          color: '#4caf50'
        },
        add: {
          icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          ),
          label: 'Hesap Ekle',
          color: '#000000'
        }
      }
    }
  ];


  // Platform butonlarını handle et - DİNAMİK VE SCALABLE
  const handlePlatformRefresh = async (platformId) => {
    switch (platformId) {
      case 'telegram':
        await onRefreshChannels();

        if (mtprotoStatus?.connected) {
          for (const channel of channels) {
            await onFetchChannelStats(channel.id);
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }

        showMessage('Telegram kanalları güncellendi!', 'success');
        break;

      case 'youtube':
        if (youtubeRef.current) {
          youtubeRef.current.handleRefresh();
        }
        break;

      case 'instagram':
        if (instagramRef.current) {
          instagramRef.current.handleRefresh();
        }
        break;

      case 'x':
        if (xRef.current) {
          xRef.current.handleRefresh();
        }
        break;

      case 'tiktok':
        if (tiktokRef.current) {
          tiktokRef.current.handleRefresh();
        }
        break;

      default:
        showMessage('Bu platform için yenileme özelliği henüz eklenmedi', 'info');
    }
  };

  const handlePlatformAddChannel = async (platformId) => {
    // Zaten bağlanıyorsa tekrar çağırma
    if (connectingPlatform) return;

    setConnectingPlatform(platformId);

    try {
      switch (platformId) {
        case 'telegram':
          onAddChannel();
          break;

        case 'youtube':
          if (youtubeRef.current) {
            await youtubeRef.current.handleAddChannel();
          }
          break;

        case 'instagram':
          if (instagramRef.current) {
            await instagramRef.current.handleAddChannel();
          }
          break;

        case 'x':
          if (xRef.current) {
            await xRef.current.handleAddChannel();
          }
          break;

        case 'tiktok':
          if (tiktokRef.current) {
            await tiktokRef.current.handleAddChannel();
          }
          break;

        default:
          showMessage('Bu platform için kanal ekleme özelliği henüz eklenmedi', 'info');
      }
    } catch (error) {
      console.error('Hesap ekleme hatası:', error);
    } finally {
      // Instagram redirect yapıyorsa zaten sayfa değişecek, 
      // diğerleri için 3 saniye sonra sıfırla
      setTimeout(() => setConnectingPlatform(null), 3000);
    }
  };

  const renderPlatformContent = () => {
    switch (selectedPlatform) {
      case 'telegram':
        return (
          <TelegramChannels
            channels={channels}
            channelStats={channelStats}
            loadingStats={loadingStats}
            mtprotoStatus={mtprotoStatus}
            onAddChannel={onAddChannel}
            onEditChannel={onEditChannel}
            onDeleteChannel={onDeleteChannel}
            onFetchChannelStats={onFetchChannelStats}
            onRefreshChannels={onRefreshChannels}
            showMessage={showMessage}
            BASE_URL={BASE_URL}
            onNavigateToLibrary={props.onNavigateToLibrary}
            onNavigateToAutomation={onNavigateToAutomation}
          />
        );

      case 'youtube':
        return (
          <YoutubeChannels
            ref={youtubeRef}
            showMessage={showMessage}
            API_URL={API_URL}
            onNavigateToLibrary={onNavigateToLibrary}
            onNavigateToAutomation={onNavigateToAutomation}
          />
        );

      case 'instagram':
        return (
          <InstagramChannels
            ref={instagramRef}
            showMessage={showMessage}
            API_URL={API_URL}
            selectedProfile={props.selectedProfile}
            onNavigateToLibrary={onNavigateToLibrary}
            onNavigateToAutomation={onNavigateToAutomation}
          />
        );

      case 'x':
        return (
          <XChannels
            ref={xRef}
            showMessage={showMessage}
            API_URL={API_URL}
            onNavigateToLibrary={onNavigateToLibrary}
            onNavigateToAutomation={onNavigateToAutomation}
          />
        );

      case 'tiktok':
        return (
          <TiktokChannels
            ref={tiktokRef}
            showMessage={showMessage}
            API_URL={API_URL}
            onNavigateToLibrary={onNavigateToLibrary}
            onNavigateToAutomation={onNavigateToAutomation}
          />
        );

      default:
        const platform = platforms.find(p => p.id === selectedPlatform);
        return (
          <div className="ct-coming-soon-container">
            <div className="ct-coming-soon-content">
              <div className="ct-coming-soon-icon" style={{ color: platform?.color }}>
                {platformIcons[selectedPlatform]}
              </div>
              <h2>{platform?.name} Entegrasyonu</h2>
              <p className="ct-coming-soon-description">
                Bu platform için entegrasyon üzerinde çalışıyoruz. Çok yakında kullanıma sunulacak!
              </p>
              <div className="ct-coming-soon-features">
                <h3>Planlanan Özellikler</h3>
                <div className="ct-features-grid">
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">🚀</span>
                    <span>Otomatik Paylaşım</span>
                  </div>
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">📊</span>
                    <span>Detaylı İstatistikler</span>
                  </div>
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">👥</span>
                    <span>Çoklu Hesap Desteği</span>
                  </div>
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">⏰</span>
                    <span>Zamanlanmış Gönderiler</span>
                  </div>
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">#️⃣</span>
                    <span>Hashtag Yönetimi</span>
                  </div>
                  <div className="ct-feature-item">
                    <span className="ct-feature-icon">📈</span>
                    <span>Performans Analizi</span>
                  </div>
                </div>
              </div>
              <div className="ct-coming-soon-footer">
                <p>🔔 Bu özellik eklendiğinde size haber vereceğiz!</p>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="ct-channels-container">
      {/* Platform Seçici Grid */}

      <div className="ct-platform-selector-grid">
        {platforms.map(platform => (
          <div
            key={platform.id}
            className={`ct-platform-card ${selectedPlatform === platform.id ? 'active' : ''} ${!platform.enabled ? 'disabled' : ''}`}
            onClick={() => platform.enabled && setSelectedPlatform(platform.id)}
            data-platform={platform.id}
            style={{
              '--platform-color': platform.color,
            }}
          >
            {platform.comingSoon && (
              <div className="ct-coming-soon-ribbon">
                <span>Yakında</span>
              </div>
            )}

            <div className="ct-platform-card-icon" style={{ color: platform.color }}>
              {platformIcons[platform.id]}
            </div>

            <div className="ct-platform-card-content">
              <h3>{platform.name}</h3>
              <p>{platform.description}</p>
            </div>

            {/* Seçili platform için dinamik butonlar */}
            {selectedPlatform === platform.id && platform.enabled && platform.actions && (
              <div className="ct-platform-action-buttons">
                {platform.actions.refresh && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlatformRefresh(platform.id);
                    }}
                    className="ct-platform-refresh-btn"
                    title={platform.actions.refresh.label}
                  >
                    <span className="ct-btn-icon">{platform.actions.refresh.icon}</span>
                    <span className="ct-btn-text">{platform.actions.refresh.label}</span>
                  </button>
                )}

                {platform.actions.add && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlatformAddChannel(platform.id);
                    }}
                    className={`ct-platform-add-btn ${connectingPlatform === platform.id ? 'ct-connecting' : ''}`}
                    title={platform.actions.add.label}
                    disabled={!!connectingPlatform}
                  >
                    <span className="ct-btn-icon">
                      {connectingPlatform === platform.id ? (
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" strokeDasharray="30" strokeDashoffset="10">
                            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
                          </circle>
                        </svg>
                      ) : platform.actions.add.icon}
                    </span>
                    <span className="ct-btn-text">
                      {connectingPlatform === platform.id ? 'Bağlanıyor...' : platform.actions.add.label}
                    </span>
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Platform İçeriği */}
      <div className="ct-platform-content">
        {renderPlatformContent()}
      </div>
    </div>
  );
};

// Renk koyulaştırma/açma fonksiyonu
const adjustColor = (color, amount) => {
  const clamp = (val) => Math.min(Math.max(val, 0), 255);

  if (color.startsWith('#')) {
    const num = parseInt(color.replace('#', ''), 16);
    const r = clamp((num >> 16) + amount);
    const g = clamp(((num >> 8) & 0x00FF) + amount);
    const b = clamp((num & 0x0000FF) + amount);
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
  }

  return color;
};

export default ChannelsTab;